import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'faq',
    template: require('./faq.component.html')
})

export class FaqComponent {

    constructor(public router: Router) {
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/front/faq/faq.component.ts
 **/